import { FormHelperText, Stack } from "@mui/material";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { QuestionSlice } from "../../../Redux/reducers/responseSlice";
import { useParams } from "react-router-dom";
import ValidationField from "../ValidationField";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { handleFieldUpdate } from "../../../Redux/reducers/responseSlice";
import { triggerSave } from "../../../Redux/actions/responseEventAction";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useTranslation } from "react-i18next";

type Props = {
  currentQuestion: QuestionSlice;
};

const PhoneField = ({ currentQuestion }: Props) => {
  const { t } = useTranslation("responses");
  const { id: studyId, surveySlug } = useParams();
  const dispatch = useAppDispatch();
  const isPreview = useAppSelector((state) => !state.response.formEditable);
  const [error, setError] = useState("");

  const currentResponse = currentQuestion.responses?.[0]?.textValue || "";
  const normalizedValue = currentResponse.startsWith("+")
    ? currentResponse.slice(1)
    : currentResponse;
  const defaultCountry = currentQuestion.properties?.defaultCountry || "gb";

  const getParsedPhone = (value: string) => {
    if (!value) {
      return null;
    }
    return parsePhoneNumberFromString(
      value,
      defaultCountry.toUpperCase() as any
    );
  };

  const handleChange = (phone: string) => {
    const nextValue = phone ? `+${phone}` : "";
    const parsed = getParsedPhone(nextValue);
    if (!nextValue || (parsed && parsed.isValid())) {
      setError("");
    }
    dispatch(
      handleFieldUpdate({
        key: "textValue",
        convertToInt: false,
        value: nextValue,
        id: currentQuestion.id,
      })
    );
  };

  const handleBlur = () => {
    const parsed = getParsedPhone(currentResponse);
    if (currentResponse && (!parsed || !parsed.isValid())) {
      setError(t("TYPE_BASED.PHONE_VALIDATION_WITH_COUNTRY_CODE"));
      return;
    }
    if (parsed && parsed.number !== currentResponse) {
      dispatch(
        handleFieldUpdate({
          key: "textValue",
          convertToInt: false,
          value: parsed.number,
          id: currentQuestion.id,
        })
      );
    }
    setError("");
    dispatch(triggerSave({ id: currentQuestion.id, studyId, surveySlug }));
  };

  return (
    <Stack
      sx={{
        width: {
          xs: "100%",
          md: "80%",
        },
        pl: "60px",
      }}
      gap={1}
    >
      <PhoneInput
        country={defaultCountry}
        inputStyle={{
          height: "48px",
          width: "100%",
          borderColor: "#e0e3eb",
        }}
        value={normalizedValue}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={isPreview}
        disableCountryCode={false}
        enableSearch={true}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}

      {currentQuestion.responses?.[0]?.questionValidation && (
        <ValidationField
          validationObject={currentQuestion.responses?.[0]?.questionValidation}
        />
      )}
    </Stack>
  );
};

export default PhoneField;
